// client/src/pages/results/ResultPortalSetup.js

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../../api/api';
import { toast } from 'react-toastify';
import { readScope } from '../../state/scopeStorage';

export default function ResultPortalSetup() {

  const { id } = useParams();
  const navigate = useNavigate();

  const orgId =
    readScope()?.org?.id;

  const [loading, setLoading] =
    useState(true);

  const [datasets, setDatasets] =
    useState([]);

  const [name, setName] =
    useState('');

  const [datasetId, setDatasetId] =
    useState('');

  const [token, setToken] =
    useState('');

  const [bgColor, setBgColor] =
    useState('#ffffff');

  const [active, setActive] =
    useState(true);

  const [allowOriginals,
    setAllowOriginals] =
    useState(true);

  const [allowOutputs,
    setAllowOutputs] =
    useState(true);

  const [allowDownload,
    setAllowDownload] =
    useState(true);

  const [expiresAt,
    setExpiresAt] =
    useState('');

  useEffect(() => {

    let cancelled = false;

    async function load() {

      try {

        const ds =
          await apiFetch(
            '/datasets/list',
            {
              method: 'POST',
              body: {
                cnt: 0,
                lmt: 200
              }
            }
          );

        if (!cancelled) {

          setDatasets(
            ds?.items || []
          );

        }

        if (
          id &&
          id !== 'new'
        ) {

          const p =
            await apiFetch(
              `/results/portal/item/${id}`
            );

          if (
            !cancelled &&
            p
          ) {

            setName(
              p.name || ''
            );

            setDatasetId(
              p.datasetId?._id ||
              p.datasetId ||
              ''
            );

            setToken(
              p.token || ''
            );

            setBgColor(
              p.bg || '#ffffff'
            );

            setActive(
              p.active !== false
            );

            setAllowOriginals(
              p.allowOriginals !== false
            );

            setAllowOutputs(
              p.allowOutputs !== false
            );

            setAllowDownload(
              p.allowDownload !== false
            );

            setExpiresAt(
              p.expiresAt
                ? p.expiresAt.substring(
                    0,
                    10
                  )
                : ''
            );

          }

        }

      } catch (err) {

        console.error(
          '[ResultPortalSetup]',
          err
        );

        toast.error(
          'Failed to load portal'
        );

      }

      if (!cancelled) {

        setLoading(false);

      }

    }

    load();

    return () => {

      cancelled = true;

    };

  }, [id]);

  const handleReturn = () => {

    navigate(
      '/results/datasets'
    );

  };

  const handleView = () => {

    if (!token) {

      toast.error(
        'Save portal first'
      );

      return;

    }

    window.open(
      `/results/display/${token}`,
      '_blank'
    );

  };

  const handleSave =
    async (e) => {

      e.preventDefault();

      if (!name) {

        toast.error(
          'Name is required'
        );

        return;

      }

      if (!datasetId) {

        toast.error(
          'Project is required'
        );

        return;

      }

      try {

        const result =
          await apiFetch(
            '/results/portal',
            {
              method: 'POST',
              body: {

                _id:
                  id !== 'new'
                    ? id
                    : undefined,

                name,

                datasetId,

                orgId,

                token,

                bg:
                  bgColor,

                active,

                allowOriginals,

                allowOutputs,

                allowDownload,

                expiresAt:
                  expiresAt ||
                  null

              }
            }
          );

        if (
          result?.token
        ) {

          setToken(
            result.token
          );

        }

        toast.success(
          'Portal saved'
        );

      } catch (err) {

        console.error(
          err
        );

        toast.error(
          'Save failed'
        );

      }

    };

  if (loading) {

    return (
      <div
        style={{
          padding: 16
        }}
      >
        Loading...
      </div>
    );

  }

  return (

    <div
      style={{
        padding: 16,
        maxWidth: 700
      }}
    >

      <div
        className="datatable-header-row"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16
        }}
      >

        <div
          style={{
            fontSize: 18,
            fontWeight: 700
          }}
        >
          {
            id === 'new'
              ? 'New Results Portal'
              : 'Edit Results Portal'
          }
        </div>

        <div
          style={{
            display: 'flex',
            gap: 8
          }}
        >

          <button
            className="btn-gray"
            onClick={
              handleReturn
            }
          >
            Return
          </button>

          <button
            className="btn-green"
            onClick={
              handleSave
            }
          >
            Save
          </button>

          <button
            className="btn-blue"
            onClick={
              handleView
            }
          >
            View
          </button>

        </div>

      </div>

      <form
        onSubmit={
          handleSave
        }
        style={{
          display: 'grid',
          gap: 14
        }}
      >

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Name</span>
          <input
            value={name}
            onChange={(e)=>
              setName(
                e.target.value
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Project</span>
          <select
            value={datasetId}
            onChange={(e)=>
              setDatasetId(
                e.target.value
              )
            }
          >
            <option value="">
              Select Project
            </option>

            {datasets.map(d => (
              <option
                key={d._id}
                value={d._id}
              >
                {d.name}
              </option>
            ))}

          </select>
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Token</span>
          <input
            value={token}
            onChange={(e)=>
              setToken(
                e.target.value
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Background</span>
          <input
            type="color"
            value={bgColor}
            onChange={(e)=>
              setBgColor(
                e.target.value
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Active</span>
          <input
            type="checkbox"
            checked={active}
            onChange={(e)=>
              setActive(
                e.target.checked
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Allow Originals</span>
          <input
            type="checkbox"
            checked={allowOriginals}
            onChange={(e)=>
              setAllowOriginals(
                e.target.checked
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Allow Outputs</span>
          <input
            type="checkbox"
            checked={allowOutputs}
            onChange={(e)=>
              setAllowOutputs(
                e.target.checked
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Allow Download</span>
          <input
            type="checkbox"
            checked={allowDownload}
            onChange={(e)=>
              setAllowDownload(
                e.target.checked
              )
            }
          />
        </label>

        <label style={{
          display:'grid',
          gridTemplateColumns:'180px 1fr',
          gap:8
        }}>
          <span>Expiration</span>
          <input
            type="date"
            value={expiresAt}
            onChange={(e)=>
              setExpiresAt(
                e.target.value
              )
            }
          />
        </label>

      </form>

    </div>

  );

}
